const $ = jQuery;

export function WooZoneNoAWSCategs( country ) {

/*
//extract script, on amazon country homepage, like: https://www.amazon.nl or https://www.amazon.sg

let country_select = document.querySelector(".nav-search-dropdown");
let exportjson = {}
for(let i=0; i<country_select.options.length;i++){
  let cc_value = country_select.options[i].value;
  cc_value = cc_value.replace("", "");
  cc_value = cc_value.replace("search-alias=", "");
  let cc_text = country_select.options[i].innerText;
  exportjson[cc_value] = cc_text;
}
console.log( JSON.stringify(exportjson) );
*/

  let data = {
    'com': {"aps":"All Departments","arts-crafts-intl-ship":"Arts & Crafts","automotive-intl-ship":"Automotive","baby-products-intl-ship":"Baby","beauty-intl-ship":"Beauty & Personal Care","stripbooks-intl-ship":"Books","computers-intl-ship":"Computers","digital-music":"Digital Music","electronics-intl-ship":"Electronics","digital-text":"Kindle Store","instant-video":"Prime Video","fashion-womens-intl-ship":"Women's Fashion","fashion-mens-intl-ship":"Men's Fashion","fashion-girls-intl-ship":"Girls' Fashion","fashion-boys-intl-ship":"Boys' Fashion","deals-intl-ship":"Deals","hpc-intl-ship":"Health & Household","kitchen-intl-ship":"Home & Kitchen","industrial-intl-ship":"Industrial & Scientific","luggage-intl-ship":"Luggage","movies-tv-intl-ship":"Movies & TV","music-intl-ship":"Music, CDs & Vinyl","pets-intl-ship":"Pet Supplies","software-intl-ship":"Software","sporting-intl-ship":"Sports & Outdoors","tools-intl-ship":"Tools & Home Improvement","toys-and-games-intl-ship":"Toys & Games","videogames-intl-ship":"Video Games"},
    'co.uk': {"aps":"All Departments","alexa-skills":"Alexa Skills","amazon-devices":"Amazon Devices","amazon-global-store":"Amazon Global Store","pantry":"Amazon Pantry","warehouse-deals":"Amazon Warehouse Deals","mobile-apps":"Apps & Games","baby":"Baby","beauty":"Beauty","stripbooks":"Books","automotive":"Car & Motorbike","popular":"CDs & Vinyl","classical":"Classical Music","clothing":"Clothing","computers":"Computers & Accessories","digital-music":"Digital Music","diy":"DIY & Tools","dvd":"DVD & Blu-ray","electronics":"Electronics & Photo","fashion":"Fashion","outdoor":"Garden & Outdoors","gift-cards":"Gift Cards","grocery":"Grocery","handmade":"Handmade","drugstore":"Health & Personal Care","local-services":"Home & Business Services","kitchen":"Home & Kitchen","industrial":"Industrial & Scientific","jewelry":"Jewellery","digital-text":"Kindle Store","appliances":"Large Appliances","lighting":"Lighting","luggage":"Luggage","luxury-beauty":"Luxury Beauty","mi":"Musical Instruments & DJ","videogames":"PC & Video Games","pets":"Pet Supplies","instant-video":"Prime Video","shoes":"Shoes & Bags","software":"Software","sports":"Sports & Outdoors","office-products":"Stationery & Office Supplies","toys":"Toys & Games","vhs":"VHS","watches":"Watches"},
    'de': {"aps":"Alle Kategorien","alexa-skills":"Alexa Skills","amazon-devices":"Amazon Geräte","amazon-global-store":"Amazon Global Store","pantry":"Amazon Pantry","warehouse-deals":"Amazon Warehouse Deals","mobile-apps":"Apps & Spiele","automotive":"Auto & Motorrad","baby":"Baby","diy":"Baumarkt","beauty":"Beauty","clothing":"Bekleidung","lighting":"Beleuchtung","stripbooks":"Bücher","english-books":"Bücher (Fremdsprachig)","office-products":"Bürobedarf & Schreibwaren","computers":"Computer & Zubehör","drugstore":"Drogerie & Körperpflege","dvd":"DVD & Blu-ray","appliances":"Elektro-Großgeräte","electronics":"Elektronik & Foto","fashion":"Fashion","videogames":"Games","outdoor":"Garten","gift-cards":"Geschenkgutscheine","industrial":"Gewerbe, Industrie & Wissenschaft","handmade":"Handmade","pets":"Haustier","photo":"Kamera & Foto","digital-text":"Kindle-Shop","classical":"Klassik","luggage":"Koffer, Rucksäcke & Taschen","kitchen":"Küche, Haushalt & Wohnen","grocery":"Lebensmittel & Getränke","luxury-beauty":"Luxury Beauty","popular":"Musik-CDs & Vinyl","digital-music":"Musik-Downloads","mi":"Musikinstrumente & DJ-Equipment","instant-video":"Prime Video","jewelry":"Schmuck","shoes":"Schuhe & Handtaschen","software":"Software","toys":"Spielzeug","sports":"Sport & Freizeit","watches":"Uhren","magazines":"Zeitschriften"},
    'fr': {"aps":"Toutes nos catégories","alexa-skills":"Alexa Skills","warehouse-deals":"Amazon Offres Reconditionnées","pantry":"Amazon Pantry","pets":"Animalerie","amazon-devices":"Appareils Amazon","mobile-apps":"Applis & Jeux","automotive":"Auto et Moto","luggage":"Bagages","beauty":"Beauté et Parfum","luxury-beauty":"Beauté Prestige","jewelry":"Bijoux","gift-cards":"Boutique chèques-cadeaux","digital-text":"Boutique Kindle","diy":"Bricolage","baby":"Bébés & Puériculture","shoes":"Chaussures et Sacs","kitchen":"Cuisine & Maison","dvd":"DVD & Blu-ray","grocery":"Epicerie","office-products":"Fournitures de bureau","appliances":"Gros électroménager","handmade":"Handmade","electronics":"High-Tech","hpc":"Hygiène et Santé","computers":"Informatique","mi":"Instruments de musique & Sono","garden":"Jardin","toys":"Jeux et Jouets","videogames":"Jeux vidéo","english-books":"Livres anglais et étrangers","stripbooks":"Livres en français","software":"Logiciels","lighting":"Luminaires et Eclairage","fashion":"Mode","watches":"Montres","popular":"Musique : CD & Vinyles","classical":"Musique classique","industrial":"Secteur industriel & scientifique","sports":"Sports et Loisirs","digital-music":"Téléchargement de musique","clothing":"Vêtements et accessoires"},
    'co.jp': {"aps":"すべてのカテゴリー","amazon-devices":"Amazon デバイス","digital-text":"Kindleストア ","instant-video":"Prime Video","alexa-skills":"Alexaスキル","digital-music":"デジタルミュージック","mobile-apps":"Android アプリ","stripbooks":"本","english-books":"洋書","popular":"ミュージック","classical":"クラシック","dvd":"DVD","videogames":"TVゲーム","software":"PCソフト","computers":"パソコン・周辺機器","electronics":"家電&カメラ","office-products":"文房具・オフィス用品","kitchen":"ホーム&キッチン","pets":"ペット用品","hpc":"ドラッグストア","beauty":"ビューティー","luxury-beauty":"ラグジュアリービューティー","food-beverage":"食品・飲料・お酒","baby":"ベビー&マタニティ","fashion":"ファッション","fashion-womens":"   レディース","fashion-mens":"   メンズ","fashion-baby-kids":"   キッズ＆ベビー","apparel":"服＆ファッション小物","shoes":"シューズ＆バッグ","watch":"腕時計","jewelry":"ジュエリー","toys":"おもちゃ","hobby":"ホビー","mi":"楽器","sporting":"スポーツ&アウトドア","automotive":"車＆バイク","diy":"DIY・工具・ガーデン","appliances":"大型家電","financial":"クレジットカード","gift-cards":"ギフト券","industrial":"産業・研究開発用品","pantry":"Amazonパントリー","warehouse-deals":"Amazonアウトレット"},
    'ca': {"aps":"All Departments","alexa-skills":"Alexa Skills","amazon-devices":"Amazon Devices","warehouse-deals":"Amazon Warehouse Deals","mobile-apps":"Apps & Games","automotive":"Automotive","baby":"Baby","beauty":"Beauty","stripbooks":"Books","apparel":"Clothing & Accessories","electronics":"Electronics","gift-cards":"Gift Cards","grocery":"Grocery","handmade":"Handmade","hpc":"Health & Personal Care","kitchen":"Home & Kitchen","industrial":"Industrial & Scientific","jewelry":"Jewelry","digital-text":"Kindle Store","french-books":"Livres en français","luggage":"Luggage & Bags","luxury-beauty":"Luxury Beauty","dvd":"Movies & TV","popular":"Music","mi":"Musical Instruments, Stage & Studio","office-products":"Office Products","lawngarden":"Patio, Lawn & Garden","pets":"Pet Supplies","shoes":"Shoes & Handbags","software":"Software","sporting":"Sports & Outdoors","tools":"Tools & Home Improvement","toys":"Toys & Games","videogames":"Video Games","watches":"Watches"},
    'cn': {"aps":"全部分类","amazon-devices":"亚马逊设备","digital-text":"Kindle商店","mobile-apps":"应用程序和游戏","amazon-global-store":"亚马逊海外购","stripbooks":"图书","music":"音乐","videogames":"游戏/娱乐","video":"音像","software":"软件","audio-visual-education":"教育音像","communications":"手机/通讯","photo-video":"摄影/摄像","electronics":"电子","music-players":"数码影音","computers":"电脑/IT","office-products":"办公用品","home-appliances":"小家电","appliances":" 大家电 ","audio-visual":" 电视/音响 ","home":"家用","home-substore":"家居","kitchen":"厨具","home-improvement":"家居装修","pets":"宠物用品","grocery":"食品","wine":"酒","beauty":"美容化妆","hpc":"个护健康","baby":"母婴用品","toys-and-games":"玩具","sporting":"运动户外休闲","apparel":"服饰箱包","shoes":"鞋靴","watches":"钟表","jewelry":"珠宝首饰","automotive":"汽车用品","mi":"乐器","gift-cards":"礼品卡","luxury-beauty":"LuxuryBeauty高端美妆店","warehouse-deals":"Z实惠"},
    'in': {"aps":"All Categories","alexa-skills":"Alexa Skills","amazon-devices":"Amazon Devices","fashion":"Amazon Fashion","amazon-global-store":"Amazon Global Store","pantry":"Amazon Pantry","appliances":"Appliances","mobile-apps":"Apps & Games","baby":"Baby","beauty":"Beauty","stripbooks":"Books","automotive":"Car & Motorbike","apparel":"Clothing & Accessories","collectibles":"Collectibles","computers":"Computers & Accessories","electronics":"Electronics","furniture":"Furniture","lawngarden":"Garden & Outdoors","gift-cards":"Gift Cards","grocery":"Grocery & Gourmet Foods","hpc":"Health & Personal Care","kitchen":"Home & Kitchen","industrial":"Industrial & Scientific","jewelry":"Jewellery","digital-text":"Kindle Store","luggage":"Luggage & Bags","luxury-beauty":"Luxury Beauty","dvd":"Movies & TV Shows","popular":"Music","mi":"Musical Instruments","office-products":"Office Products","pets":"Pet Supplies","shoes":"Shoes & Handbags","software":"Software","sporting":"Sports, Fitness & Outdoors","home-improvement":"Tools & Home Improvement","toys":"Toys & Games","videogames":"Video Games","watches":"Watches"},
    'it': {"aps":"Tutte le categorie","apparel":"Abbigliamento","alexa-skills":"Alexa Skill","grocery":"Alimentari e cura della casa","pantry":"Amazon Pantry","warehouse-deals":"Amazon Warehouse Deals","mobile-apps":"App e Giochi","automotive":"Auto e Moto","beauty":"Bellezza","gift-cards":"Buoni Regalo","office-products":"Cancelleria e prodotti per ufficio","kitchen":"Casa e cucina","popular":"CD e Vinili ","amazon-devices":"Dispositivi Amazon","electronics":"Elettronica","diy":"Fai da te","dvd":"Film e TV","garden":"Giardino e giardinaggio","toys":"Giochi e giocattoli","jewelry":"Gioielli","appliances":"Grandi elettrodomestici","handmade":"Handmade","lighting":"Illuminazione","industrial":"Industria e Scienza","computers":"Informatica","digital-text":"Kindle Store","stripbooks":"Libri","english-books":"Libri in altre lingue","fashion":"Moda","digital-music":"Musica Digitale","watches":"Orologi","baby":"Prima infanzia","pets":"Prodotti per animali domestici","hpc":"Salute e cura della persona","shoes":"Scarpe e borse","software":"Software","sporting":"Sport e tempo libero","mi":"Strumenti musicali e DJ","luggage":"Valigeria","videogames":"Videogiochi"},
    'es': {"aps":"Todos los departamentos","alexa-skills":"Alexa Skills","grocery":"Alimentación y bebidas","pantry":"Amazon Pantry","mobile-apps":"Appstore para Android","baby":"Bebé","beauty":"Belleza","diy":"Bricolaje y herramientas","gift-cards":"Cheques regalo","automotive":"Coche y moto","sporting":"Deportes y aire libre","amazon-devices":"Dispositivos de Amazon","electronics":"Electrónica","luggage":"Equipaje","appliances":"Grandes electrodomésticos","handmade":"Handmade","kitchen":"Hogar y cocina","lighting":"Iluminación","industrial":"Industria y ciencia","computers":"Informática","mi":"Instrumentos musicales","lawngarden":"Jardín","jewelry":"Joyería","toys":"Juguetes y juegos","stripbooks":"Libros","english-books":"Libros en idiomas extranjeros","fashion":"Moda","digital-music":"Música Digital","popular":"Música: CDs y vinilos","office-products":"Oficina y papelería","dvd":"Películas y TV","pets":"Productos para mascotas","warehouse-deals":"Productos Reacondicionados","watches":"Relojes","apparel":"Ropa y accesorios","hpc":"Salud y cuidado personal","software":"Software","digital-text":"Tienda Kindle","videogames":"Videojuegos","shoes":"Zapatos y complementos"},
    'com.mx': {"aps":"Todos los departamentos","alexa-skills":"Alexa Skills","automotive":"Auto","baby":"Bebé","amazon-devices":"Dispositivos de Amazon","electronics":"Electrónicos","dvd":"Películas y Series de TV","instant-video":"Prime Video","digital-text":"Tienda Kindle","fashion":"Ropa, Zapatos y Accesorios","fashion-womens":"   Mujeres","fashion-mens":"   Hombres","fashion-girls":"   Niñas","fashion-boys":"   Niños","fashion-baby":"   Bebé","grocery":"Alimentos y Bebidas","sporting":"Deportes y Aire Libre","hi":"Herramientas y Mejoras del Hogar","kitchen":"Hogar y Cocina","industrial":"Industria y ciencia","mi":"Instrumentos musicales","toys":"Juegos y juguetes","stripbooks":"Libros","pets":"Mascotas","popular":"Música","office-products":"Oficina y Papelería","handmade":"Productos Handmade","warehouse-deals":"Remates de Almacén","hpc":"Salud, Belleza y Cuidado Personal","software":"Software","gift-cards":"Tarjetas de Regalo","videogames":"Videojuegos"},
    'com.br': {"aps":"Todos os departamentos","alexa-skills":"Alexa Skills","grocery":"Alimentos e Bebidas","mobile-apps":"Apps e Jogos","automotive":"Automotivo","baby":"Bebês","beauty":"Beleza","fashion-luggage":"Bolsas, Malas e Mochilas","toys":"Brinquedos e Jogos","home":"Casa","popular":"CD e Vinil","computers":"Computadores e Informática","kitchen":"Cozinha","amazon-devices":"Dispositivos Amazon","dvd":"DVD e Blu-Ray","appliances":"Eletrodomésticos","electronics":"Eletrônicos","sporting":"Esportes e Aventura","hi":"Ferramentas e Materiais de Construção","videogames":"Games","garden":"Jardim e Piscina","stripbooks":"Livros","digital-text":"Loja Kindle","office-products":"Material para Escritório e Papelaria","furniture":"Móveis e Decoração","pets":"Pet Shop","instant-video":"Prime Video","fashion":"Roupas, Calçados e Joias","fashion-womens":"   Feminino","fashion-mens":"   Masculino","fashion-girls":"   Meninas","fashion-boys":"   Meninos","fashion-baby":"   Bebês","hpc":"Saúde e Cuidados Pessoais"},
    'com.au': {"aps":"All Departments","alexa-skills":"Alexa Skills","amazon-devices":"Amazon Devices","amazon-global-store":"Amazon Global Store","mobile-apps":"Apps & Games","audible":"Audible Audiobooks","automotive":"Automotive","baby":"Baby","beauty":"Beauty","stripbooks":"Books","popular":"CDs & Vinyl","fashion":"Clothing, Shoes & Accessories","fashion-womens":"   Women","fashion-mens":"   Men","fashion-girls":"   Girls","fashion-boys":"   Boys","fashion-baby":"   Baby","computers":"Computers","electronics":"Electronics","gift-cards":"Gift Cards","hpc":"Health, Household & Personal Care","home":"Home","home-improvement":"Home Improvement","digital-text":"Kindle Store","fashion-luggage":"Luggage & Travel Gear","luxury-beauty":"Luxury Beauty","movies-tv":"Movies & TV","grocery":"Pantry Food & Drinks","pets":"Pet Supplies","software":"Software","sporting":"Sports, Fitness & Outdoors","office-products":"Stationery & Office Products","toys":"Toys & Games","videogames":"Video Games"},
    'ae': {"aps":"All Categories","amazon-devices":"Amazon Devices","fashion":"Amazon Fashion","amazon-global-store":"Amazon Global Store","appliances":"Appliances","automotive":"Automotive Parts & Accessories","baby":"Baby","beauty":"Beauty & Personal Care","stripbooks":"Books","computers":"Computer & Accessories","electronics":"Electronics","gift-cards":"Gift Cards","grocery":"Grocery & Gourmet Food","hpc":"Health, Household & Baby Care","garden":"Home & Garden","kitchen":"Kitchen & Dining","fashion-luggage":"Luggage & Travel Gear","mi":"Musical Instruments","office-products":"Office Products","pets":"Pet Supplies","sports":"Sports","tools":"Tools & Home Improvement","toys":"Toys & Games","videogames":"Video Games"},
    "nl": {"aps":"Alle afdelingen","amazon-devices":"Amazon-apparaten","automotive":"Auto en motor","baby":"Babyproducten","beauty":"Beauty en persoonlijke verzorging","stripbooks":"Boeken","gift-cards":"Cadeaubonnen","popular":"Cd's en lp's","electronics":"Elektronica","dvd":"Films en tv","hpc":"Gezondheid en persoonlijke verzorging","pets":"Huisdierbenodigdheden","office-products":"Kantoorproducten","digital-text":"Kindle Store","fashion":"Kleding, schoenen en sieraden","home-improvement":"Klussen en gereedschap","grocery":"Levensmiddelen","mi":"Muziekinstrumenten","misc":"Overig","instant-video":"Prime Video","software":"Software","toys":"Speelgoed en spellen","sports":"Sport en outdoor","outdoor":"Tuin, terras en gazon","videogames":"Videogames","home":"Wonen en keuken","industrial":"Zakelijk, industrie en wetenschap"},
    "sg": {"aps":"All Departments","amazon-global-store":"Amazon International Store","automotive":"Automotive","baby":"Baby","beauty":"Beauty & Personal Care","stripbooks":"Books","fashion":"Clothing, Shoes & Jewelry","computers":"Computer & Accessories","electronics":"Electronics","grocery":"Grocery","hpc":"Health, Household & Personal Care","home":"Home","kitchen":"Kitchen & Dining","office-products":"Office Products","pets":"Pet Supplies","sporting":"Sports & Outdoors","home-improvement":"Tools & Home Improvement","toys":"Toys & Games","videogames":"Video Games"},
    "sa": {"aps":"جميع الأقسام","mi":"آلات موسيقية","amazon-devices":"أجهزة Amazon","home-improvement":"أدوات وتحسينات المنزل","fashion":"أزياء Amazon","videogames":"ألعاب الفيديو","toys":"الألعاب والدمى","electronics":"الإلكترونيات","grocery":"البقالة والطعام الفاخر","beauty":"الجمال والعناية الشخصية","sports":"الرياضة","hpc":"الصحة، الأسرة والعناية بالطفل","industrial":"الصناعة والعلم","arts-crafts":"الفنون والحرف والخياطة","kitchen":"المطبخ والطعام","garden":"المنزل والحديقة","baby":"طفل","automotive":"قطع وإكسسوارات السيارات","stripbooks":"كتب","amazon-global-store":"متجر أمازون العالمي","pets":"مستلزمات الحيوانات الأليفة","office-products":"منتجات المكتب","home":"منتجات المنزل"},
    "com.tr": {"aps":"Tüm Kategoriler","garden":"Bahçe","baby":"Bebek","computers":"Bilgisayarlar","electronics":"Elektronik","home":"Ev","kitchen":"Ev ve Mutfak","pets":"Evcil Hayvan Malzemeleri","gift-cards":"Hediye Kartları","stripbooks":"Kitaplar","beauty":"Kişisel Bakım ve Kozmetik","fashion":"Moda","mi":"Müzik Aletleri","office-products":"Ofis Ürünleri","toys":"Oyuncaklar ve Oyunlar","videogames":"PC ve Video Oyunları","instant-video":"Prime Video","hpc":"Sağlık ve Bakım","sports":"Spor","diy":"Yapı Market"},
    "se": {"aps":"Alla kategorier","amazon-devices":"Amazon-enheter","baby":"Babyprodukter","home-improvement":"Bygg, el & verktyg","stripbooks":"Böcker","electronics":"Elektronik","movies-tv":"Film & TV-serier","automotive":"Fordon","home":"Hem & kök","arts-crafts":"Hobby & hantverk","pets":"Husdjursprodukter","hpc":"Hälsa, vård & hushåll","industrial":"Industriella verktyg & produkter","fashion":"Kläder, skor & accessoarer","office-products":"Kontorsprodukter & skolmaterial","toys":"Leksaker & spel ","popular":"Musik","mi":"Musikinstrument","gift-cards":"Presentkort","instant-video":"Prime Video","software":"Programvara","beauty":"Skönhet & kroppsvård","sporting":"Sport & outdoor","garden":"Trädgård","videogames":"TV-spel & konsoler"},
    "pl": {"aps":"Wszystkie kategorie","arts-crafts":"Arts & crafts","office-products":"Biuro","industrial":"Biznes, przemysł i nauka","home":"Dom i kuchnia","baby":"Dziecko","electronics":"Elektronika","movies-tv":"Filmy i programy TV","videogames":"Gry wideo","mi":"Instrumenty muzyczne","gift-cards":"Karty podarunkowe","computers":"Komputery i akcesoria","stripbooks":"Książki","automotive":"Motoryzacja","popular":"Muzyka","fashion":"Odzież, obuwie i akcesoria","garden":"Ogród","software":"Oprogramowanie","home-improvement":"Renowacja domu","sporting":"Sport i turystyka","beauty":"Uroda","amazon-devices":"Urządzenia Amazon","toys":"Zabawki i gry","hpc":"Zdrowie i gospodarstwo domowe","pets":"Zwierzęta"},
    'eg': {"aps":"All Categories","amazon-devices":"Amazon Devices","fashion":"Amazon Fashion","arts-crafts":"Arts, Crafts &amp; Sewing","automotive":"Automotive Parts &amp; Accessories","baby":"Baby","beauty":"Beauty &amp; Personal Care","stripbooks":"Books","electronics":"Electronics","grocery":"Grocery &amp; Gourmet Food","hpc":"Health, Household &amp; Baby Care","garden":"Home &amp; Garden","home":"Home Related","industrial":"Industrial &amp; Scientific","mi":"Musical Instruments","office-products":"Office Products","pets":"Pet Supplies","software":"Software","sports":"Sports","home-improvement":"Tools &amp; Home Improvement","toys":"Toys &amp; Games","videogames":"Video Games"},
  }

  return WooZoneNoAWS_isset(data, country) ? data[country] : []
}

export function WooZoneNoAWS_Country_List(){
  return [
    {
      'alias': 'com',
      'label': 'United States',
      'flag': 'assets/flags/US.gif',
    },
    {
      'alias': 'co.uk',
      'label': 'United Kingdom',
      'flag': 'assets/flags/UK.gif',
    },
    {
      'alias': 'de',
      'label': 'Deutschland',
      'flag': 'assets/flags/DE.gif',
    },
    {
      'alias': 'fr',
      'label': 'France',
      'flag': 'assets/flags/FR.gif',
    },
    {
      'alias': 'co.jp',
      'label': 'Japan',
      'flag': 'assets/flags/JP.gif',
    },
    {
      'alias': 'ca',
      'label': 'Canada',
      'flag': 'assets/flags/CA.gif',
    },
    {
      'alias': 'cn',
      'label': 'China',
      'flag': 'assets/flags/CN.gif',
    },
    {
      'alias': 'in',
      'label': 'India',
      'flag': 'assets/flags/IN.gif',
    },
    {
      'alias': 'it',
      'label': 'Italia',
      'flag': 'assets/flags/IT.gif',
    },
    {
      'alias': 'es',
      'label': 'España',
      'flag': 'assets/flags/ES.gif',
    },
    {
      'alias': 'com.mx',
      'label': 'Mexico',
      'flag': 'assets/flags/MX.jpg',
    },
    {
      'alias': 'com.br',
      'label': 'Brazil',
      'flag': 'assets/flags/BR.gif',
    },
    {
      'alias': 'com.au',
      'label': 'Australia',
      'flag': 'assets/flags/AU.png',
    },
    {
      'alias': 'ae',
      'label': 'UAE',
      'flag': 'assets/flags/UAE.gif',
    },
    {
      'alias': 'nl',
      'label': 'Netherlands',
      'flag': 'assets/flags/NL.gif',
    },
    {
      'alias': 'sg',
      'label': 'Singapore',
      'flag': 'assets/flags/SG.gif',
    },
    {
      'alias': 'sa',
      'label': 'Saudi Arabia',
      'flag': 'assets/flags/SA.gif',
    },
    {
      'alias': 'com.tr',
      'label': 'Turkey',
      'flag': 'assets/flags/TR.gif',
    },
    {
      'alias': 'se',
      'label': 'Sweden',
      'flag': 'assets/flags/SE.gif',
    },
    {
      'alias': 'pl',
      'label': 'Poland',
      'flag': 'assets/flags/PL.gif',
    },
    {
      'alias': 'eg',
      'label': 'Egypt',
      'flag': 'assets/flags/EG.gif',
    },
  ]
}

export function WooZoneNoAWS_isset( arr, var_args ) {
  for (var i=1, k=arguments.length; i<k; ++i) {
    if (!arr || !arr.hasOwnProperty(arguments[i]) )
      return false
    arr = arr[arguments[i]];
  }
  return true
}

export function WooZoneParser( alias, content, { lang = 'en', prevState = {} } )
{
  console.log( 'WooZoneParser: ', alias, lang, prevState );
  let base = {};
  if ( alias !== 'paged' ) {
    return base;
  }

  let isfrom = WooZoneNoAWS_isset( prevState, 'isfrom' ) ? prevState['isfrom'] : '';
  let prevPerPage = WooZoneNoAWS_isset( prevState, 'pagination', 'per_page' ) ? prevState['pagination']['per_page'] : -999;

  let $content = $(content);
  let $breadcrumb = $content.find(".s-breadcrumb");
  let breadcrumbText = $breadcrumb.text();
  breadcrumbText = $.trim( breadcrumbText );

  let paginationWrapperExp = '.s-result-list.s-search-results .s-result-item ul.a-pagination';
  let $paginationWrapper = $content.find(`${paginationWrapperExp}`);
  let lastPage = -1;
  if ( $paginationWrapper.find('li.a-last') && $paginationWrapper.find('li.a-last').prev() ) {
    lastPage = $paginationWrapper.find('li.a-last').prev().text();
    lastPage = parseInt( lastPage, 10 );
  }
  console.log( 'WooZoneParser: ', alias, $paginationWrapper, lastPage, $paginationWrapper.find('li.a-last').prev() );

  // [update] on 2020-nov-30
  // ex: 1-16 of over 100,000 results for "lcd"
  let max = 20;
  //let regex = /(\d+)(?:-|–| a )(\d+) .* (\d+(?:(?:[\.,\s]{1})\d+)?\s)/gmi;
  let regex = /(\d+)(?:-|–| a )(\d+) (?:[^\d]+) (\d+(?:(?:[\.,\s]{1})\d+)?)\s/gmi;

  if ( 'cn' === lang ) {
    max = 10;
    regex = /(\d+)-(\d+)条， 共超过(\d+(?:(?:[\.,]{1})\d+)?)/gmi;
  }
  else if ( 'co.jp' === lang ) {
    max = 10;
    regex = /(\d+(?:(?:[\.,]{1})\d+)?)(?: 以上 のうち | のうち )(\d+)-(\d+)/gm;
  }
  else if ( 'com.tr' === lang ) {
    max = 10;
    regex = /(\d+(?:(?:[\.,]{1})\d+)?)(?:[^\d]+)(\d+)-(\d+)/gm;
  }

  let matches = regex.exec(breadcrumbText);
  console.log( 'WooZoneParser: ', alias, matches );
  if ( !matches || !matches.length ) {
    return base;
  }

  //:: start, end, totals
  if ( WooZoneNoAWS_isset( matches, 1 ) ) {
    if ( 'co.jp' === lang || 'com.tr' === lang ) {
      base['totals'] = parseInt( matches[1].replace(/[\.,\s ]+/gi, '') );
    }
    else {
      base['start'] = parseInt( matches[1] );
    }
  }

  if ( WooZoneNoAWS_isset( matches, 2 ) ) {
    if ( 'co.jp' === lang || 'com.tr' === lang ) {
      base['start'] = parseInt( matches[2] );
    }
    else {
      base['end'] = parseInt( matches[2] );
    }
  }

  if ( WooZoneNoAWS_isset( matches, 3 ) ) {
    if ( 'co.jp' === lang || 'com.tr' === lang ) {
      base['end'] = parseInt( matches[3] );
    }
    else {
      base['totals'] = parseInt( matches[3].replace(/[\.,\s ]+/gi, '') );
    }
  }

  //:: per page
  if ( WooZoneNoAWS_isset( base, 'start' ) && WooZoneNoAWS_isset( base, 'end' ) ) {
    base['per_page'] = parseInt( base['end'] + 1 - base['start'] );

    if ( 'pagination' === isfrom && prevPerPage > 0 && base['per_page'] !== prevPerPage ) {
      base['per_page'] = prevPerPage;
    }
  }

  //:: totals
  if ( WooZoneNoAWS_isset( base, 'per_page' ) && lastPage > 0 ) {
    let tmp = parseInt( lastPage * base['per_page'], 10 );

    if ( ! WooZoneNoAWS_isset( base, 'totals' ) ) {
      base['totals'] = tmp;
    }
    else if ( base['totals'] > tmp ) {
      base['totals'] = tmp;
    }
  }

  //:: FIXES
  if ( WooZoneNoAWS_isset( base, 'totals' ) && WooZoneNoAWS_isset( base, 'per_page' ) ) {
    let tmp = parseInt( max * base['per_page'], 10 );

    if ( base['totals'] > tmp ) {
      base['totals'] = tmp;
    }
  }

  if ( WooZoneNoAWS_isset( base, 'end' ) && WooZoneNoAWS_isset( base, 'totals' ) ) {
    if ( base['end'] >= base['totals'] ) {
      delete base['per_page'];
    }
  }

  console.log( 'WooZoneParser: ', alias, breadcrumbText, matches, base );
  return base;
}

export function WooZoneMakeID(length=10) {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

export function WooZoneChunk(arr, chunkSize) {
  let R = [];
  for (let i=0,len=arr.length; i<len; i+=chunkSize)
    R.push(arr.slice(i,i+chunkSize));
  return R;
}

export function WooZoneHumanFileSize(bytes, si) {
    var thresh = si ? 1000 : 1024;
    if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    var units = si
        ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
        : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
    var u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
}

export function WooZoneGetHostName(url) {
  var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
  return match[2];
  }
  else {
      return null;
  }
}

export function WooZoneGetDomain(url) {
  var hostName = WooZoneGetHostName(url);
  var domain = hostName;
  
  if (hostName != null) {
      var parts = hostName.split('.').reverse();
      
      if (parts != null && parts.length > 1) {
          domain = parts[1] + '.' + parts[0];
              
          if (hostName.toLowerCase().indexOf('.co.uk') != -1 && parts.length > 2) {
            domain = parts[2] + '.' + domain;
          }

          if (hostName.toLowerCase().indexOf('.co.jp') != -1 && parts.length > 2) {
            domain = parts[2] + '.' + domain;
          }

          if (hostName.toLowerCase().indexOf('.com.au') != -1 && parts.length > 2) {
            domain = parts[2] + '.' + domain;
          }

          if (hostName.toLowerCase().indexOf('.com.mx') != -1 && parts.length > 2) {
            domain = parts[2] + '.' + domain;
          }

          if (hostName.toLowerCase().indexOf('.com.br') != -1 && parts.length > 2) {
            domain = parts[2] + '.' + domain;
          }

          if (hostName.toLowerCase().indexOf('.com.tr') != -1 && parts.length > 2) {
            domain = parts[2] + '.' + domain;
          }

      }
  }
  
  return domain;
}

export function WooZoneContentTrimmer( DOM='' ) {
  function clean_text( content ) {
    content = content.replace(/\s\s+/g, ' ');
    content = content.trim();
    return content;
  }
  
  // console.time('contentTrimmer');

  DOM = clean_text( DOM );

  let page = $('<div/>').html(DOM).contents().parent();

  // some unwanted HTML tags
  page.find("header").remove();
  page.find("style").remove();
  page.find("link").remove();
  page.find("input").remove();
  page.find("select").remove();

  // footer large menu
  page.find("#navFooter").remove();

  // reviews
  page.find("#reviewsMedley").remove();

  // Frequently bought together
  page.find("#sims-consolidated-1_feature_div").remove();

  // Sponsored products related to this item
  page.find("#sims-consolidated-2_feature_div").remove();

  // Customers who bought this item also bought
  page.find("#sims-consolidated-3_feature_div").remove();

  // Sponsored products related to this item
  page.find("#sponsoredProducts2_feature_div").remove();

  page.find("*").removeAttr('style');
  page.find("script").each( function(){
    var that = $(this);
    if( that.text().indexOf("twister-js-init-dpx-data") == -1 ){
      that.remove()
    }
  })

  // console.timeEnd('contentTrimmer');

  return page.html();
}

export function WooZoneImportUrlGetDebugStep() {
  let ret = {
    status: 'invalid',
    value: '',
    asparam: '',
  };
  const queryString = window.location.search;
  //console.log('queryString', queryString);

  const urlParams = new URLSearchParams(queryString);
  //console.log('debug_step', urlParams.has('debug_step'));
  if ( urlParams.has('debug_step') ) {
    let debug_step = urlParams.get('debug_step')
    //console.log('debug_step', debug_step);
    ret = {
      ...ret,
      status: 'valid',
      value: debug_step,
      asparam: `&debug_step=${debug_step}`,
    };
  }
  return ret;
}